import validate from 'validate.js'

const constraints = {
  to: {
    presence: true
  },
  from: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
